// @flow
import React, {Component} from 'react';
import styled, {css} from 'styled-components';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {
  Icon,
  IconLookup
} from 'trustar-2.0/components';
import { ThemeType } from 'trustar-2.0/types';
import { DefaultTheme } from 'trustar-2.0/themes';

// Types Merged with Reactstrap and converted to Flow
type DropdownProps = {
  disabled?: boolean,
  dropup?: boolean,
  direction?: 'up' | 'down' | 'left' | 'right' ,
  group?: boolean,
  isOpen?: boolean,
  nav?: boolean,
  active?: boolean,
  addonType?: boolean | 'prepend' | 'append',
  tag?: string,
  toggle?: Function,
  className?: string,
  cssModule?: Object,
  inNavbar?: boolean,
  setActiveFromChild?: boolean,
  selected?: string,
  placeholder?: string,
  children?: React.Element<typeof DropdownMenu> | React.Element<typeof DropdownItem>,
  borderless?: boolean | 'true' | 'false',
  size?: 'wide' | 'slim' | number | string,
  theme?: ThemeType,
};

const initialValues = {
  // theme: DefaultTheme, This overrides everything
};

// Style
const sizes = {wide: '14rem', slim: '6rem'};
const StyledDropdown = styled(Dropdown)`
  && {
    display: inline-block;
    font-size: ${({theme}) => theme.FontSizes.P};
    background-color: ${({theme}) => theme.ThemeColors.SURFACE.hex};
    color: ${({theme}) => theme.ThemeColors.TEXT.hex};
    padding: 0.5rem;
    border: 1px solid ${({theme, borderless}) => borderless ? 'transparent' : theme.ThemeColors.BORDER.hex};
    cursor: pointer;
    user-select: none;
    position: relative;

    .dropdown-text {
      width: ${({size}) => {
        if (size) {
          return sizes[size] ? sizes[size] : size + 'rem';
        } else {
          return 'inherit';
        }
      }};
      margin-right: 0.5rem;
    }
      ${props => props.disabled && css`
        opacity: 0.5;
        background-color: ${({theme}) => theme.ThemeColors.SURFACE.X700 /* TODO: SHADES_OF_BLACK_50 */};
        pointer-events: none;
        cursor: default;
      `}

    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      display: none;
      float: left;
      min-width: 10rem;
      padding: 0.5rem 0;
      margin: 0.125rem 0 0;
      font-size: 1rem;
      color: #212529;
      text-align: left;
      list-style: none;
      background-color: ${({theme}) => theme.ThemeColors.SURFACE.hex};
      background-clip: padding-box;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 0.25rem;

      &.show {
        display: block;
      }
    }
    }



`;



const StyledDropdownToggle = styled(DropdownToggle)`
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      margin-right: 0.1rem;
    }
`;

const StyledDropdownMenu = styled(DropdownMenu)`

`;
StyledDropdownMenu.defaultProps = initialValues;

const StyledDropdownItem = styled(DropdownItem)`
  && {
      font-size: ${({theme}) => theme.FontSizes.P};
      background-color: ${({theme}) => theme.ThemeColors.SURFACE.hex};
      color: ${({theme}) => theme.ThemeColors.TEXT.hex};
      user-select: none;

      :hover {
        background-color: ${({theme}) => theme.ThemeColors.SEARCH_BAR.X500};
        color: ${({theme}) => theme.ThemeColors.TEXT.hex};
      }

      :active, :focus {
        background-color: ${({theme}) => theme.ThemeColors.SURFACE.X50 /* TODO: SHADES_OF_BLACK_50 */};
        border: initial;
        outline: 0;
        color: ${({theme}) => theme.ThemeColors.TEXT.hex};
      }

      display: block;
      width: 100%;
      padding: 0.25rem 1.5rem;
      clear: both;
      text-align: inherit;
      white-space: nowrap;
      border: 0;
  }
`;
StyledDropdownItem.defaultProps = initialValues;

class StandardDropdown extends Component {
  props: DropdownProps;
  state = {
    dropdownOpen: false, // TODO: Initial Values
  };

//  ----Template----

  render() {
    const {dropdownOpen} = this.state;

    return (
      <StyledDropdown {...this.props} isOpen={dropdownOpen} disabled={this.props.disabled} toggle={this.toggle}>
        <StyledDropdownToggle disabled={this.props.disabled} tag={'div'}>
          <span className={'dropdown-text'}>{this.props.selected || this.props.placeholder || 'Select'} </span>
          <Icon icon={IconLookup.CHEVRON_DOWN} />
        </StyledDropdownToggle>
        {this.props.children}
      </StyledDropdown>
    );
  }

// ----Methods----
  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };
}

// $FlowFixMe: Weird error.
StandardDropdown.defaultProps = initialValues;


export {StandardDropdown as Dropdown, StyledDropdownMenu as DropdownMenu, StyledDropdownItem as DropdownItem};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Dropdowns/Dropdown.js